import React from 'react';
import { useSelector } from 'react-redux';
import { Loader, MessageBlock } from '@getro/rombo';
import { Box } from 'rebass/styled-components';
import { activeNetworkSelector } from 'redux/selectors';
import { useCompanyLayoutName } from 'hooks/useCompanyLayoutName';
import withMainLayout from '../../hocs/withMainLayout';
import useCompany from '../../hooks/useCompany';
import { CompanyProfileLayout } from '../../components/layout/CompanyProfileLayout';
import strings from '../../strings';
import JobsTableWithFilters from '../../components/organisms/jobsTableWithFilters';
import { MainLayoutHeader } from '../../components/atoms/mainLayoutHeader';
import usePageHook from '../../hooks/usePageHook';

const CompanyJobs = () => {
  const { company, error, initialized } = useCompany();
  const activeNetwork = useSelector(activeNetworkSelector);
  const { isCompanyProfile, isInCompanyProfileOrNetwork } = useCompanyLayoutName(initialized);
  usePageHook('Company jobs');

  if (error) {
    return (
      <>
        <MainLayoutHeader title="Company profile" />
        <Box>
          {error !== 404 && <MessageBlock type="error" content={strings.genericError} />}
          {error === 404 && (
            <MessageBlock
              type="warning"
              title="Company not found"
              content="It looks like the URL is not correct or the company doesn’t belong to the active network."
            />
          )}
        </Box>
      </>
    );
  }

  if (!initialized) {
    return (
      <>
        <MainLayoutHeader title="Company profile" />
        <Loader />
      </>
    );
  }

  return (
    <CompanyProfileLayout
      isCompanyNetwork={activeNetwork.isCompany}
      fullWidth
      description={strings.companyProfile.description}
      isInCompanyProfileOrNetwork={isInCompanyProfileOrNetwork}
    >
      <JobsTableWithFilters
        isCompanyProfile={isCompanyProfile}
        company={company}
        source="employer_profile"
        sx={{ px: '0px' }}
      />
    </CompanyProfileLayout>
  );
};

export default withMainLayout(CompanyJobs, { containerProps: { pb: '0px', minHeight: '100vh' } });
